<template>
  <div v-if="deliveryInfo" class="picker-apply-deliver box m-b30">
    <div class="c-6 f-16 m-b15">收货人信息</div>
    <div class="row b-2-gray">
      <el-row class="c-6 f-12 lh-20">
        <el-col :span="2" style="width: 66px">收货地址:</el-col>
        <el-col :span="22" class="single-line">
          {{ deliveryInfo.logisticsAddress }}
        </el-col>
      </el-row>
      <el-row class="c-6 f-12 m-t5 lh-20">
        <el-col :span="2" style="width: 66px">联 系 人:</el-col>
        <el-col :span="22">
          {{ deliveryInfo.logisticsName }} {{ deliveryInfo.logisticsMobile }}
        </el-col>
      </el-row>
      <el-row v-if="deliveryInfo.expectConsignDate" class="c-6 f-12 m-t5 lh-20">
        <el-col :span="2" style="width: 88px">期望发货日期:</el-col>
        <el-col :span="22">
          {{ deliveryInfo.expectConsignDate }}
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PickerApplyDeliver',
  components: {},
  props: {
    deliveryInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.picker-apply-deliver {
  .row {
    padding: 20px 20px 20px 20px;
    // border-top: 1px solid #999999;
  }
  .tip {
    height: 44px;
    line-height: 44px;
  }
}
</style>
